import './polyfills';
import './integrations';
// The shell owns the @font-face declarations when this app runs as a remote;
// only the standalone document loads them itself.
import './fonts.css';
import './globalStyleImports';

import {createBrowserHistory} from 'history';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Router} from 'react-router-dom';

import {AppEntryProviders} from './AppEntryProviders';
import {initializeAppStartup} from './appStartup';
import {urlPrefixed} from './config';
import {AppWithRoutes} from './routes/AppWithRoutes';
import uninstallServiceWorker from './uninstallServiceWorker';
import {captureAppEntryAssetCache} from './util/datadog/appEntryAssetCache';
import {setGlobalHistory} from './util/globalHistory';

uninstallServiceWorker();

// Startup sends the first queries, whose links read the global history.
const history = createBrowserHistory({basename: urlPrefixed(undefined, false)});
setGlobalHistory(history);
initializeAppStartup();
captureAppEntryAssetCache({shell: false});

const root = createRoot(document.getElementById('root')!);

root.render(
  <AppEntryProviders>
    <Router history={history}>
      <AppWithRoutes />
    </Router>
  </AppEntryProviders>
);
